export default __webpack_public_path__ + "static/media/fleche_teachers.1026bb77.svg";